import { alertService } from 'components/Varios/alert_service'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { authenticationService } from 'services/authentication.service'
import { ObtenerDetalleHistorial, ObtenerInformacionGeneralSolicitudes } from './FunctionsSolicitudVacaciones'
import { EstadosParseSolicitudesVacaciones, InformacionDetalleHistorialSolicitudVacaciones, InformacionGeneralSolicitudes, PlanificacionSolicitudVacaciones, TablaDetalleHistorialSolicitudVacaciones, TiposReplanificacion } from './TypesSolicitudVacaciones'
import { Row, Col, Table, Container } from "reactstrap";
import CardPlanificaciones from './CardPlanificaciones'
import CardSolicitudes from './CardSolicitudes'
import CardHistorialSolicitudesVacaciones from './CardHistorialSolicitudesVacaciones'
import { ResponseRequest } from 'components/Types/GeneralTypes'
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion'
import Cargando from 'components/Varios/Cargando'
import { ObtenerFechaFromIsoFormat, ParseHorasFormato } from 'functions/DatesFunctions'
import { DownloadDocument } from 'helpers/files'
import CardReplanificacionJustificacion from './CardReplanificacionJustificacion'
import SolicitudVacacionesContextProvider from 'Context/SolicitudesVacacionesContext'
import AlertNew, { TiposAlerta } from 'components/Varios/AlertNew'
import { FormatNumbersTwoDigitsTwoDecimals } from 'functions/FormatFunctions'
import { ROL_APROBADOR, ROL_DIRECTIVO_UNIDAD } from 'Context/SideBarContext'
import Mantenimiento from 'components/Varios/Mantenimiento'
import PdfSVG from "assets/icons/Permisos/PDF(azul).svg"


type StateSolicitudVacaciones = {
    datosGenerales: InformacionGeneralSolicitudes,
    loadingDG: boolean,
    solicitudPlanificada?: PlanificacionSolicitudVacaciones,
    replanificacionSeleccionada?: PlanificacionSolicitudVacaciones,
    tipoReplanificacion?: TiposReplanificacion,
    mensajeError: string,
    idRegimenLaboral: number[],
    fechaControlHorario: Date,
    
}

type StateModalHistoricoDetalle = {
    loadingInformacion: boolean,
    tabladetalle: TablaDetalleHistorialSolicitudVacaciones[] | undefined,
    anio: number,
    totalDiasOrdinarios: number
}

type StateCardReplanificacion = {
    planificacionSeleccionada?: PlanificacionSolicitudVacaciones
}


export type CheckPlanificacion = {
    fechaDesde: string | null,
    fechaHasta: string | null
}


export default function SolicitudVacaciones() {

    const defaultState: StateSolicitudVacaciones = {
        datosGenerales: {
            planificaciones: [], planificacionesNoEjecutadas: [], solicitudes: [], solicitudesReintegro: []
            , solicitudReplanificacionIngresada: null, diasPendientes: -1, anio: -1,
            feriados: [],
            esSubrogante: false,
            fechasLicencia: [],
            usuarioNoPuedeSolicitarPorAccionPersonal: false,
            fechasPermisos: [],
            historial: [], acuerdoMediosElectronicos: true, historialReplanificacion: [],
            horaEntrada: "", horaSalida: "",
            fechaCorteSoloJustificaPlanificacion: undefined,
            horaInicioAlmuerzo: "", horaFinAlmuerzo: "", tiempoAlmuerzo: "",
            nroMaximoDiasOrdinariosImputablesVacaciones: 22,
            esAprobador: false,
            cantidadMinutosMinimosPermisos: 5,
            fechaHoraActual: new Date().toString(),
            nroDiasAnticipacionReplanificacion: 10,
            idRegimenLaboralSolicitaVacaciones :-1,
            fechafincontrato:null,
            puedeSolicitarPorHorario:false


        },
        loadingDG: false,
        solicitudPlanificada: undefined,
        replanificacionSeleccionada: undefined,
        tipoReplanificacion: undefined,
        mensajeError: "",
        idRegimenLaboral: [],
        fechaControlHorario: new Date(),
        
    }

    const defaultStateModalHistoricoDetalle: StateModalHistoricoDetalle = {
        loadingInformacion: false,
        tabladetalle: undefined,
        anio: -1,
        totalDiasOrdinarios: -1
    }

    const horaInicioHorarioSolicitudes = new Date();
    horaInicioHorarioSolicitudes.setHours(8, 0, 0);
    const horaFinHorarioSolicitudes = new Date();
    horaFinHorarioSolicitudes.setHours(17, 30, 0);

    const [stateSolicitudVacaciones, setstateSolicitudVacaciones] = useState<StateSolicitudVacaciones>(defaultState)
    const [stateModalHistoricoDetalle, setstateModalHistoricoDetalle] = useState<StateModalHistoricoDetalle>(defaultStateModalHistoricoDetalle)
    const [statefechasComparePlanificacion, setstatefechasComparePlanificacion] = useState<CheckPlanificacion | undefined>(undefined)
    const [mostrarCardReplanificacion, setmostrarCardReplanificacion] = useState<boolean>(false)





    function HandleErrorInformacionGeneral(message?: string) {
        const mensaje = message ?? "Ha ocurrido un error al intentar obtener informacion de sus solicitudes"
        alertService.error(mensaje)
    }

    function VerifyChangeDate(fechaDesde, fechaHasta) {
        setstatefechasComparePlanificacion({ fechaDesde, fechaHasta });
    }

    async function ObtenerDatosGenerales() {
        setstateSolicitudVacaciones({ ...stateSolicitudVacaciones, loadingDG: true })
        const respuesta = await ObtenerInformacionGeneralSolicitudes(HandleErrorInformacionGeneral)
        const listaRegimenServidor: number[] = authenticationService.currentUserValue.regimen_usuario;
        if (respuesta.status === 200) {
            setstateSolicitudVacaciones({ ...defaultState, datosGenerales: respuesta.dataResponse, loadingDG: false, idRegimenLaboral: listaRegimenServidor })
        }
        else {
            setstateSolicitudVacaciones({ ...defaultState, loadingDG: false, mensajeError: respuesta.errorMessage ?? "" })
        }

    }

    useEffect(() => {
        window.location.href = "https://th.espol.edu.ec/";
        //ObtenerDatosGenerales();
    }, [])

    useEffect(() => {

        // var serverTime = new Date(Number(datosMarcacion.marcacion_horario.fechahora));
        // var localTime = new Date();
        // var timeDiff = serverTime.getTime() - localTime.getTime();

        const currentStateSolicitud = { ...stateSolicitudVacaciones }


        const rolesUsuario: string[] = authenticationService.currentUserValue.roles_usuario;
        const rolSinHorario = rolesUsuario.includes(ROL_DIRECTIVO_UNIDAD) || rolesUsuario.includes(ROL_APROBADOR);


        // const horaentradaservidor = stateSolicitudVacaciones.datosGenerales.horaEntrada;
        // const horasalidaservidor = stateSolicitudVacaciones.datosGenerales.horaSalida;


        // const horaEntrada = horaentradaservidor.split(":")[0]
        // const minutoEntrada = horaentradaservidor.split(":")[1]

        // const horaSalida = horasalidaservidor.split(":")[0]
        // const minutoSalida = horasalidaservidor.split(":")[1]

        // horaInicioHorarioSolicitudes.setHours(horaEntrada)

        // const PuedeSolicitarPorHorario = horaInicioHorarioSolicitudes.getTime() <= stateSolicitudVacaciones.fechaControlHorario.getTime() && stateSolicitudVacaciones.fechaControlHorario.getTime() <= horaFinHorarioSolicitudes.getTime()

        // var timer = setInterval(() => setstateSolicitudVacaciones({
        //     ...currentStateSolicitud,
        //     fechaControlHorario: new Date((new Date().getTime() + 0)),
        //     puedeSolicitarPorHorario: PuedeSolicitarPorHorario || rolSinHorario
        // }), 1000)






        // return function cleanup() {
        //     clearInterval(timer)
        // }

    }, [stateSolicitudVacaciones]);




    function handleCheck(p: PlanificacionSolicitudVacaciones | undefined) {


        setstateSolicitudVacaciones({ ...stateSolicitudVacaciones, solicitudPlanificada: p, replanificacionSeleccionada: undefined, tipoReplanificacion: undefined })



        // if (accion === "SOL") {
        //     setstateSolicitudVacaciones({ ...stateSolicitudVacaciones, solicitudPlanificada: p, replanificacionSeleccionada: undefined, tipoReplanificacion: undefined })
        // }
        // else if (accion === TiposReplanificacion.REPLANIFICACION || accion === TiposReplanificacion.REPLANIFICACIONSOLICITADA) {
        //     setstateSolicitudVacaciones({ ...stateSolicitudVacaciones, solicitudPlanificada: undefined, replanificacionSeleccionada: p, tipoReplanificacion: accion })
        // }
    }






    const cardPlanificacionVacaciones = useMemo(() => {
        const { planificaciones, anio } = stateSolicitudVacaciones.datosGenerales
        return (
            <CardPlanificaciones
                planificaciones={planificaciones}
                anioPlanificacion={anio}
                handleCheckPlanificacion={(p) => handleCheck(p)}
                planificacionVerificar={statefechasComparePlanificacion}
                onClickMostrarReplanificacion={() => setmostrarCardReplanificacion(true)}

            />
        )
    }, [stateSolicitudVacaciones.datosGenerales.planificaciones, stateSolicitudVacaciones.datosGenerales.solicitudes, statefechasComparePlanificacion])
    // }, [stateSolicitudVacaciones.datosGenerales.planificaciones, stateSolicitudVacaciones.datosGenerales.solicitudes, stateSolicitudVacaciones.solicitudPlanificada, stateSolicitudVacaciones.replanificacionSeleccionada ,statefechasComparePlanificacion])

    const cardSolicitudVacaciones = useMemo(() => {
        const {
            solicitudes,
            solicitudesReintegro,
            solicitudReplanificacionIngresada,
            diasPendientes,
            anio,
            feriados,
            fechasLicencia,
            fechasPermisos,
            planificaciones,
            acuerdoMediosElectronicos,
            planificacionesNoEjecutadas,
            horaEntrada,
            horaSalida,
            fechaCorteSoloJustificaPlanificacion,
            nroMaximoDiasOrdinariosImputablesVacaciones,
            horaInicioAlmuerzo,
            horaFinAlmuerzo,
            tiempoAlmuerzo,
            cantidadMinutosMinimosPermisos,
            idRegimenLaboralSolicitaVacaciones,
            fechafincontrato,
            puedeSolicitarPorHorario
        } = stateSolicitudVacaciones.datosGenerales

        const { solicitudPlanificada, idRegimenLaboral, fechaControlHorario } = stateSolicitudVacaciones



        if (mostrarCardReplanificacion) {
            return undefined;
        }

        return (
            <CardSolicitudes
                diasPendientes={diasPendientes}
                solicitudes={solicitudes}
                solicitudesReintegro={solicitudesReintegro}
                solicitudReplanificacion={solicitudReplanificacionIngresada}
                anioSolicitud={anio}
                feriados={feriados}
                onInsertSolicitud={async () => await ObtenerDatosGenerales()}
                solicitudPlanificada={solicitudPlanificada}
                fechasLicencia={fechasLicencia}
                fechasPermisosMedicos={fechasPermisos}
                onChangeFechaConPlanificacion={(fechaDesde, fechaHasta) => VerifyChangeDate(fechaDesde, fechaHasta)}
                planificaciones={planificaciones}
                idRegimenLaboral={idRegimenLaboral}
                idRegimenLaboralSolicitaVacaciones = {idRegimenLaboralSolicitaVacaciones}
                acuerdoMediosElectronicos={acuerdoMediosElectronicos}
                planificacionesNoEjecutadas={planificacionesNoEjecutadas}

                horarioLaboral={
                    {
                        horaEntrada,
                        horaSalida
                    }
                }
                fechaCorteSoloJustificaPlanificacion={fechaCorteSoloJustificaPlanificacion ?? new Date()}
                horarioAlmuerzo={
                    {
                        horaInicio: horaInicioAlmuerzo,
                        horaFin: horaFinAlmuerzo,
                        tiempo: tiempoAlmuerzo
                    }
                }
                nroMaximoDiasOrdinariosImputablesVacaciones={nroMaximoDiasOrdinariosImputablesVacaciones}
                cantidadMinutosMinimosPermisos={cantidadMinutosMinimosPermisos}
                fechafincontrato={fechafincontrato}
                puedeSolicitarPorHorario={puedeSolicitarPorHorario}///////////cuidado nunca debe ser true sino, la variable
            />
        )
    }, [mostrarCardReplanificacion, stateSolicitudVacaciones.datosGenerales, stateSolicitudVacaciones.solicitudPlanificada, stateSolicitudVacaciones.idRegimenLaboral, stateSolicitudVacaciones.replanificacionSeleccionada, stateSolicitudVacaciones.tipoReplanificacion])

    function escogerIndice(indihist: number, indiReferencia: number) {
        if (indihist < indiReferencia) {
            return { indiceColor: indihist, indiReferencia }
        }
        indiReferencia = indiReferencia + 5 === indihist ? indihist : indiReferencia;
        if (indiReferencia === indihist) {
            return { indiceColor: 4, indiReferencia }
        }
        var indiceColor = indihist;
        if (indiceColor > indiReferencia) {
            indiceColor = indiceColor - indiReferencia - 1
        }


        return { indiceColor, indiReferencia };

    }

    async function VerDetalleHistorico(anioDeseado: number) {
        setstateModalHistoricoDetalle({ ...stateModalHistoricoDetalle, loadingInformacion: true, anio: anioDeseado })
        const respuestaRequestDetalle: ResponseRequest = await ObtenerDetalleHistorial(anioDeseado);
        if (respuestaRequestDetalle.status !== 200 || respuestaRequestDetalle.dataResponse === undefined) {
            setstateModalHistoricoDetalle({ ...stateModalHistoricoDetalle, loadingInformacion: false })
            alertService.error(respuestaRequestDetalle.errorMessage ?? "Ha ocurrido un inconveniente al intentar obtener el detalle historico de ese año")
            return
        }
        const data: InformacionDetalleHistorialSolicitudVacaciones = respuestaRequestDetalle.dataResponse;
        setstateModalHistoricoDetalle({ tabladetalle: data.tabladetalle, totalDiasOrdinarios: data.totalDiasOrdinarios, loadingInformacion: false, anio: anioDeseado })

    }

    const cardsHistorialSolicitudesVacaciones = useMemo(() => {
        const historial = stateSolicitudVacaciones.datosGenerales.historial;
        const colores_secuencia = ["#74c9ed", "#195eff", "#961fc2", "#ff7ae9", "#ff7729"];
        if (historial.length > 0) {
            var indiReferencia = 4;
            const cardsHistorial = historial.map((infohist, indihist) => {
                var resultado = escogerIndice(indihist, indiReferencia);
                const indiceColor = resultado.indiceColor;
                indiReferencia = resultado.indiReferencia;
                return (
                    <Col key={"cardHistorialSolicitudes " + indihist} xl={4} lg={6} md={6} sm={12} className="mt-5">
                        <CardHistorialSolicitudesVacaciones
                            informacion={infohist}
                            color={colores_secuencia[indiceColor]}
                            verDetalleHistorico={(anio: number) => VerDetalleHistorico(anio)}
                            historialReplanificacion={stateSolicitudVacaciones.datosGenerales.historialReplanificacion.find((c) => c.key === infohist.key)?.value}
                        />
                    </Col>
                )
            })
            return cardsHistorial
        }
    }, [stateSolicitudVacaciones.datosGenerales.historial, stateSolicitudVacaciones.datosGenerales.historialReplanificacion])



    const contenidoModalDetalleHistorico: any = useMemo(() => {
        if (stateModalHistoricoDetalle.loadingInformacion) {
            return <Cargando />
        }
        else if (stateModalHistoricoDetalle.tabladetalle !== undefined && stateModalHistoricoDetalle.tabladetalle.length === 0) {
            return (
                <>
                    <br />
                    <p className='text-center'>No hay detalle de solicitud de vacaciones</p>
                </>
            )
        }
        else if (stateModalHistoricoDetalle.tabladetalle !== undefined && stateModalHistoricoDetalle.tabladetalle.length > 0 && stateModalHistoricoDetalle.loadingInformacion === false) {
            const datosUsuario = authenticationService.currentUserValue.token;
            const tabla =

                <>
                    <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                        <thead className="cabecerasDetallehistorialSolic">
                            <tr className="" >
                                <th> Tipo de solicitud</th>
                                <th> Número de la solicitud</th>
                                <th> F. Solicitud</th>
                                <th> F. Desde</th>
                                <th> F. Hasta</th>
                                <th> F. Hasta Antic.</th>
                                <th> Horas </th>
                                <th> Días Ordinarios</th>
                                <th> Estado</th>

                                <th> Documento</th>


                            </tr>
                        </thead>
                        <tbody>
                            {
                                stateModalHistoricoDetalle.tabladetalle.map((infoHist, indinfoHist) => {
                                    // const textodias = (infoHist.diasOrdinarios !== 1 && infoHist.diasOrdinarios !== -1) ? "días" : (infoHist.diasOrdinarios == 1 || infoHist.diasOrdinarios == -1) ? "día" : "";
                                    const textodias = "día(s)";
                                    const mostrarDias = infoHist.estado !== EstadosParseSolicitudesVacaciones.ANULADA && infoHist.estado !== EstadosParseSolicitudesVacaciones.RECHAZADA
                                    const esvacacionxresolucion = infoHist.esxresolucion == "S" && infoHist.nrodocautorizacion != null 
                                    return (
                                        <tr className="rowHistorialSolicitudVacaciones" key={"rowDetalleHistorico " + indinfoHist + stateModalHistoricoDetalle.anio}>
                                            <td className="">
                                                <div className="">
                                                    {infoHist.tipoSolicitud}
                                                </div>

                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {infoHist.numeroSolicitud}
                                                </div>

                                            </td>
                                            <td>
                                            <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaSolicitud)}
                                                </div>
                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaInicio)}
                                                </div>

                                            </td>
                                            <td className="">
                                                <div className="">
                                                    {ObtenerFechaFromIsoFormat(infoHist.fechaFin)}
                                                </div>

                                            </td>

                                            <td className="">
                                                <div className="">
                                                    {
                                                        infoHist.fechaFinAnticipada ? ObtenerFechaFromIsoFormat(infoHist.fechaFinAnticipada) : ""
                                                    }
                                                </div>

                                            </td>



                                            <td className="">
                                                <div className="">
                                                    {ParseHorasFormato(infoHist.totalHoras)}
                                                </div>

                                            </td>
                                            <td className="tdDiasOrdinarios">
                                                <div className="pl-1 containerDiasOrdinariosResumen">
                                                    {
                                                        mostrarDias && (
                                                            <div id="nroDia">
                                                                {FormatNumbersTwoDigitsTwoDecimals(infoHist.diasOrdinarios)}
                                                            </div>
                                                        )
                                                    }
                                                    {
                                                        mostrarDias && (
                                                            <div id="textoDias">
                                                                {" " + textodias}
                                                            </div>
                                                        )
                                                    }
                                                </div>

                                            </td>


                                            <td className="">
                                                <div className="">
                                                    {infoHist.estado}
                                                </div>

                                            </td>
                                            <td>
                                                {
                                                    infoHist.referenciaArchivo && !esvacacionxresolucion &&

                                                    <i
                                                        className='fas fa-file-pdf iconBlue'
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaArchivo, datosUsuario, "Solicitud Vacacaciones.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Solicitud de Vacaciones en pdf ">

                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaAnulacion &&

                                                    <i
                                                        className='fas fa-file-pdf iconBlue'
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaAnulacion, datosUsuario, "Solicitud de Anulación de Vacacaciones.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Solicitud de Anulación de Vacaciones en pdf ">

                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaReintegro &&

                                                    <i
                                                        className='fas fa-file-pdf iconBlue'
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaReintegro, datosUsuario, "Solicitud de Reintegro de Vacacaciones.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Solicitud de Reintegro de Vacaciones en pdf ">

                                                    </i>
                                                }
                                                {
                                                    infoHist.referenciaAP &&

                                                    <i
                                                        className='fas fa-file-pdf iconBlue'
                                                        onClick={async () => await DownloadDocument(infoHist.referenciaAP, datosUsuario, "Acción de Personal de Solicitud de Vacaciones.pdf")}
                                                        data-toggle="tooltip" data-placement="top" title="Acción de Personal de Solicitud de Vacaciones en pdf ">

                                                    </i>
                                                }
                                            </td>



                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                        <tfoot>
                            <tr className="tableFooterHistorialSolicVac">
                                <td colSpan={5}></td>
                                <td className="totaldias" colSpan={4}>TOTAL: {stateModalHistoricoDetalle.totalDiasOrdinarios.toString()} {(stateModalHistoricoDetalle.totalDiasOrdinarios == 1 || stateModalHistoricoDetalle.totalDiasOrdinarios == -1) ? " día" : " días"}</td>
                                <td colSpan={1}></td>

                            </tr>
                        </tfoot>
                    </Table>
                </>

            return tabla;
        }
    }, [stateModalHistoricoDetalle])

    if (stateSolicitudVacaciones.loadingDG) {
        return <Cargando mensaje='Cargando Solicitudes'></Cargando>
    }
    else if (stateSolicitudVacaciones.mensajeError !== "") {
        return (
            <div className='content'>

            </div>
        )
    }

    const contenidoMensajeAlerta = (
        <div>
            {/* <div className={"mb-1"}> {"Para solicitar  "} <u> vacaciones No Planificadas </u> {" (por días u horas), seleccione en la opción Solicitudes de, la pestaña "} <strong>Permiso imputable a vacaciones</strong> {"o, utilice la opción"} <strong>Reprogramación de Vacaciones</strong> {", para replanificar sus vacaciones; recuerde hacerlo por lo menos quince días antes de la fecha prevista. "}</div> */}
            <div className={"mb-1"}> {"Para solicitar  "} <u> vacaciones No Planificadas </u> {" debe "} <strong>reprogramar las vacaciones</strong> {"o solicitar"} <strong>permiso imputable a vacaciones</strong> </div>
            <div>
                El horario de uso de esta opción para realizar solicitudes de vacaciones, permisos imputables a vacaciones, reprogramación y reintegro de vacaciones es de 8:00 a 16:30 en días laborables
            </div>
        </div>
    )

    // return (
    //     <div className='content'>
    //         <Mantenimiento/>
    //     </div>
    // )

    //return (
    //    <div className='content'>
    //        <Mantenimiento/>
    //    </div>
    //)

    

    return (
        <div className='content'>
            <SolicitudVacacionesContextProvider>

                <div className="titulo_seccion_permisos mb-3">
                    Solicitudes de vacaciones, permisos imputables a vacaciones, reintegro, reprogramación
                    <a href="https://talentohumano.espol.edu.ec/Sitio/archivos/PRO-DHO-011_Gestion_de_Vacaciones_V5.pdf" target="_blank">
                        <img
                            src={PdfSVG} // Cambia la ruta al lugar donde esté almacenado tu SVG
                            className="acciones"
                            alt="Guía de gestión de vacaciones"
                            data-toggle="tooltip"
                            data-placement="top"
                            title="Guía de gestión de vacaciones"
                            style={{ width: 24, height: 24 }} // Ajusta el tamaño según necesites
                        />
                    </a>
                </div>
                <Row className="mb-3 align-items-center">
                    <Col md={10}>
                        <AlertNew
                            cabeceraTitulo={"ADVERTENCIA !!!"}
                            mensaje={" "}
                            tipo={TiposAlerta.SOLICITUD_VACACIONES}
                            mensajeHTML={contenidoMensajeAlerta}
                            oncloseElement={() => { ; }}
                        />
                    </Col>

                </Row>


                {/* {
                    !stateSolicitudVacaciones.datosGenerales.esAprobador &&
                    <Row className="mb-3">
                        <Col md={10}>
                            <AlertNew
                                cabeceraTitulo={"ADVERTENCIA !!!"}
                                mensaje={`El horario de uso de esta opción para realizar solicitudes de vacaciones, permisos imputables a vacaciones, reprogramación y reintegro de vacaciones es de 8:00 a 16:30 en días laborables`}
                                tipo={TiposAlerta.SOLICITUD_VACACIONES_ERROR}
                                oncloseElement={() => { ; }}
                            />
                        </Col>


                    </Row>
                } */}

                {
                    stateSolicitudVacaciones.datosGenerales.esSubrogante &&
                    <Row className="mb-3">
                        <Col md={10}>
                            <AlertNew
                                cabeceraTitulo={"ADVERTENCIA !!!"}
                                mensaje={"Ud no puede solicitar vacaciones con su cargo de subrogación. Deberá finalizar la subrogación para regresar a su cargo anterior y luego solicitar las vacaciones"}
                                tipo={TiposAlerta.SOLICITUD_VACACIONES}
                                oncloseElement={() => { ; }}
                            />
                        </Col>
                    </Row>


                }

                <Row>
                    <Col className="styleColCardPlanificacionVacaciones" md={12} xl={4}>
                        {cardPlanificacionVacaciones}
                    </Col>
                    <Col md={12} xl={8}>
                        {
                            cardSolicitudVacaciones
                        }

                        {/* {
                        stateSolicitudVacaciones.replanificacionSeleccionada !== undefined && stateSolicitudVacaciones.solicitudPlanificada === undefined &&
                        <CardReplanificacionVacaciones
                            planificacionInicial={stateSolicitudVacaciones.replanificacionSeleccionada}
                            handleOcultarCard={() => { setstateSolicitudVacaciones({ ...stateSolicitudVacaciones, replanificacionSeleccionada: undefined }) }}
                            feriados={stateSolicitudVacaciones.datosGenerales.feriados}
                            maxLengthJustifica={300}
                            solicitudesVacaciones={stateSolicitudVacaciones.datosGenerales.solicitudes}
                            solicitudesReintegro={stateSolicitudVacaciones.datosGenerales.solicitudesReintegro}
                            tipoReplanificacion={stateSolicitudVacaciones.tipoReplanificacion ?? TiposReplanificacion.REPLANIFICACIONSOLICITADA}
                            acuerdoMediosElectronicos = {stateSolicitudVacaciones.datosGenerales.acuerdoMediosElectronicos}
                        />
                    } */}

                        {
                            mostrarCardReplanificacion &&
                            // true &&
                            <CardReplanificacionJustificacion
                                planificaciones={stateSolicitudVacaciones.datosGenerales.planificaciones}
                                planificacionesNoEjecutadas={stateSolicitudVacaciones.datosGenerales.planificacionesNoEjecutadas}
                                anio={stateSolicitudVacaciones.datosGenerales.anio}
                                handleOcultarCard={() => setmostrarCardReplanificacion(false)}
                                diasPendientes={stateSolicitudVacaciones.datosGenerales.diasPendientes}
                                feriados={stateSolicitudVacaciones.datosGenerales.feriados}
                                fechasPermisosMedicos={stateSolicitudVacaciones.datosGenerales.fechasPermisos}
                                fechasLicencia={stateSolicitudVacaciones.datosGenerales.fechasLicencia}
                                usuarioNoPuedeSolicitarPorAccionPersonal={stateSolicitudVacaciones.datosGenerales.usuarioNoPuedeSolicitarPorAccionPersonal}
                                solicitudes={stateSolicitudVacaciones.datosGenerales.solicitudes}
                                solicitudesReintegro={stateSolicitudVacaciones.datosGenerales.solicitudesReintegro}
                                onInsertSolicitud={async () => await ObtenerDatosGenerales()}
                                fechaHoraActual={stateSolicitudVacaciones.datosGenerales.fechaHoraActual}
                                nroDiasAnticipacion={stateSolicitudVacaciones.datosGenerales.nroDiasAnticipacionReplanificacion}
                            />
                        }
                    </Col>

                    {/*{*/}

                    {/*    cardsHistorialSolicitudesVacaciones*/}
                    {/*}*/}

                </Row>
                <ModalConfirmacion
                    show={stateModalHistoricoDetalle.tabladetalle !== undefined || stateModalHistoricoDetalle.loadingInformacion}
                    asyncAccion={false}
                    asyncClose={false}
                    closeAfterAccion={false}
                    hideBotonCerrar={false}
                    mensajeConfirmacion={""}
                    nombreBotonAccion={"Cerrar"}
                    onClose={() => setstateModalHistoricoDetalle({ tabladetalle: undefined, loadingInformacion: false, anio: -1, totalDiasOrdinarios: -1 })}
                    size={"lg"}
                    contentModal={contenidoModalDetalleHistorico}
                    tituloModal={"Detalle vacaciones " + stateModalHistoricoDetalle.anio}
                    classNameAllModal={""}
                />
            </SolicitudVacacionesContextProvider>


        </div>
    )
}
